import React, { useState, useRef, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

// Components
import SignatureCanvas from 'react-signature-canvas';
import Button from '../Button';

// Translations
import commonMessages from '../../messages/common';
import messages from '../../views/Permission/messages';

// Icons
import PenIcon from '../../assets/icons/pen2-icon.inline.svg';
import useDataLayer from '../../hooks/useDataLayer';
import { steps } from '../../utils/routes';

const SignaturePad = props => {
  const { field, form } = props;
  const { formatMessage } = useIntl();
  const [isDrawing, setDrawing] = useState(false);
  const wrapperRef = useRef();
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const canvasRef = React.createRef();

  const [pushEvent] = useDataLayer();

  // set canvas width and height equal to wrapper
  useLayoutEffect(() => {
    if (wrapperRef.current) {
      setDimensions({
        width: wrapperRef.current.offsetWidth,
        height: wrapperRef.current.offsetHeight,
      });
    }
  }, []);

  function handleClear() {
    pushEvent({
      eventLabel: 'clear signature',
      eventAction: steps.Permission,
    });
    canvasRef.current.clear();
    setDrawing(false);
    form?.setFieldValue(field.name, null);
  }

  function handleMouseDown() {
    setDrawing(true);
  }

  function handleMouseUp(e) {
    form?.setFieldValue(field.name, e.target.toDataURL());
  }

  return (
    <div
      className="relative bg-primary-25 border border-dashed border-primary-400 rounded-md w-full h-full"
      ref={wrapperRef}
      style={{
        touchAction: 'none',
      }}
    >
      <Button
        className="absolute right-0 top-0 mr-20 mt-20 w-auto smd:w-auto"
        style={{
          zIndex: 2,
        }}
        size="small"
        theme="secondary"
        type="button"
        width="auto"
        onClick={handleClear}
      >
        {formatMessage(commonMessages.clear)}
      </Button>
      <SignatureCanvas
        ref={canvasRef}
        {...field}
        canvasProps={{
          style: { zIndex: 1 },
          className: 'sigCanvas relative w-full h-220 cursor-pointer',
          name: 'signature',
          onMouseDown: handleMouseDown,
          onTouchStart: handleMouseDown,
          onMouseUp: handleMouseUp,
          onTouchEnd: handleMouseUp,
          ...(dimensions?.width ? { width: dimensions.width } : {}),
          ...(dimensions?.height ? { height: dimensions.height } : {}),
        }}
        clearOnResize={false}
      />
      {!isDrawing && (
        <div className="absolute inset-x-0 text-center text-primary-400 -mt-140 ">
          <PenIcon alt="signature icon" className="m-auto mb-20 fill-primary" />
          <div>{formatMessage(messages.permissionSignature)}</div>
        </div>
      )}
    </div>
  );
};

SignaturePad.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};

export default SignaturePad;
